import StringUtils from './stringUtils';
import {
  BOOKING_TYPE,
  ORDER_COVERAGE_STATUS,
  ORDER_INVOICE_STATUS,
  ORDER_STATUS
} from '../redux/api/orders/orders.model';
import { TRIP_STATUS } from '../redux/api/trips/trips.model';

export const useParseUrlSelections = (): ((
  value: string,
  urlKey: string
) => Record<string, boolean>) => {
  const utilMap = {
    bookingMode: (val: string): string => val as BOOKING_TYPE,
    coverage: (val: string): string =>
      StringUtils.toReadableOrderCoverageString(val as ORDER_COVERAGE_STATUS),
    orderStatus: (val: string): string => StringUtils.getOrderStatusLabel(val as ORDER_STATUS),
    tripStatus: (val: string): string => StringUtils.getSegmentStatusLabel(val as TRIP_STATUS),
    invoiceStatus: (val: string): string =>
      StringUtils.getOrderInvoiceStatusLabel(val as ORDER_INVOICE_STATUS)
  };

  return (value: string, urlKey: string): Record<string, boolean> => {
    const fn = utilMap[urlKey as keyof typeof utilMap];
    const selections = value.split('+');

    return selections.reduce((a, c) => {
      const key = fn(c);
      a[key] = true;
      return a;
    }, {} as Record<string, boolean>);
  };
};
